import repository from '@/utils/repository';

const resource = '/move/MNG_SalesReport001';

export default {
    search: (data) => {
        return repository.post(`${resource}/search`, {
            ...data
        });
    }
};
